
import React, { Component } from 'react'
import ReisadviezenTravelservices from '../components/Reisadviezen/ReisadviezenTravelservices'
import dynamicPortal from '../utils/dynamicPortal';

export class ReisadviezenTravelservicesPortal extends Component {
  render() {
    return dynamicPortal.load('.js-react-reisadviezen-travelservices', (config) => (
      <ReisadviezenTravelservices config={config} />
    ))
  }
}

export default ReisadviezenTravelservicesPortal



// WEBPACK FOOTER //
// ./src/portals/ReisadviezenTravelservicesPortal.js